import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import React, { useState, useEffect, useRef } from 'react'
import BottomBarGraph from './BottomBarGraph';

const AgeGenderGraph = () =>{
   const [getVaccineTable, setVaccineTable] = useState() 
   const [getSeriesMale, setSeriesMale] = useState()
   const [getSeriesFemale, setSeriesFemale] = useState()
   const [getCategories, setCategories] = useState()
    const [errorCode, setErrorCode] = useState()
      const [errorMessage, setErrorMessage] = useState()
      const [errorSubject, setErrorSubject] = useState()
      const [errorOccured, seterrorOccured] = useState(false)
const { getRefreshDateFilter, getStateFilter, getAgeGroupFilter, getGenderFilter,
        getVaccineTypeFilter } =
        useGeoState()

        debugger;
const { data: vaccineTableData, error: VaccineDataError } = useGeoFetch(
    '',
    '',
    'vaccineAgeGenderData',
    'STATE',false,
    {geo_parent:'US',refresh_date:getRefreshDateFilter,state:getStateFilter,gender:getGenderFilter,age_group:getAgeGroupFilter,vaccine_type:getVaccineTypeFilter},
    'POST'
  )

  useEffect(() => {
    if (vaccineTableData !== null && vaccineTableData !== undefined) {
      if (vaccineTableData.response_code === 200) {
        setVaccineTable(vaccineTableData.response_data)
      } else {
        setErrorCode(vaccineTableData.response_code)
        setErrorMessage(vaccineTableData.response_message)
        setErrorSubject(vaccineTableData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [vaccineTableData])

    var seriesMale = [];
    var seriesFemale = [];
    var ageGroups = [];
    var Vaccines = [];
 
  
  function ProcessData(){
    ageGroups = [
    ...new Set(getVaccineTable.map(item => item.age_group).filter(Boolean))
    ];
    setCategories(ageGroups);

    Vaccines = [
    ...new Set(getVaccineTable.map(item => item.vaccine_type).filter(Boolean))
    ];

    if (getGenderFilter.toLowerCase() == 'male'){
        const maleData =  getVaccineTable;
         var colorMale = '';
        Vaccines.forEach((item) => {
        var data = [];
        ageGroups.forEach((agegrp) => {
            colorMale = item.toLowerCase() == 'menacwy'?'#c71e83':item.toLowerCase() == 'menb'?'#15A796':'#AEE2D5'
            var filteredData = maleData.filter(data => data.vaccine_type.toLowerCase() == item.toLowerCase() 
             && data.age_group.toLowerCase() == agegrp.toLowerCase());
             
            data.push(parseInt(filteredData[0].count));
        })

        seriesMale.push({name:item, data:data, color:colorMale});
        seriesFemale = [];
    })
    setSeriesMale(seriesMale);
    setSeriesFemale([]);
    }
    else if (getGenderFilter.toLowerCase() == 'female'){
        const femaleData = getVaccineTable;
        var colorFemale = '';
    Vaccines.forEach((item) => {
        var data = [];
        ageGroups.forEach((agegrp) => {
           colorFemale = item.toLowerCase() == 'menacwy'?'#c71e83':item.toLowerCase() == 'menb'?'#15A796':'#AEE2D5'
            var filteredData = femaleData.filter(data => data.vaccine_type.toLowerCase() == item.toLowerCase() 
            &&  data.age_group.toLowerCase() == agegrp.toLowerCase());
             
            data.push(parseInt(filteredData[0].count));
        })

        seriesFemale.push({name:item, data:data, color:colorFemale});
        seriesMale = [];
    })
        setSeriesFemale(seriesFemale);
        setSeriesMale([]);
    }
    else{
        const maleData = getVaccineTable.filter(item => 
            (item.gender || "").toLowerCase() === "male"
        );
        var colorMaleCase = '';
        Vaccines.forEach((item) => {
        var data = [];
        ageGroups.forEach((agegrp) => {
          colorMaleCase = item.toLowerCase() == 'menacwy'?'#c71e83':item.toLowerCase() == 'menb'?'#15A796':'#AEE2D5'
            var filteredData = maleData.filter(data => data.vaccine_type.toLowerCase() == item.toLowerCase() 
            &&  data.age_group.toLowerCase() == agegrp.toLowerCase());
             
            data.push(parseInt(filteredData[0].count));
        })

        seriesMale.push({name:item, data:data, color:colorMaleCase});
    })
        setSeriesMale(seriesMale);

          const femaleData = getVaccineTable.filter(item => 
            (item.gender || "").toLowerCase() === "female"
        );
        var colorFemaleCase = '';
        Vaccines.forEach((item) => {
        var data = [];
        ageGroups.forEach((agegrp) => {
           colorFemaleCase = item.toLowerCase() == 'menacwy'?'#c71e83':item.toLowerCase() == 'menb'?'#15A796':'#AEE2D5'
            var filteredData = femaleData.filter(data => data.vaccine_type.toLowerCase() == item.toLowerCase() 
            &&  data.age_group.toLowerCase() == agegrp.toLowerCase());
             
            data.push(parseInt(filteredData[0].count));
        })

        seriesFemale.push({name:item, data:data, color:colorFemaleCase});
    })
        setSeriesFemale(seriesFemale);
    }
  } 

  useEffect(() =>{
    
  if(getVaccineTable){
     seriesMale = [];
     seriesFemale = [];
     ProcessData();
  }
  },[getVaccineTable])
   

return (
  <>
    {getVaccineTable && getSeriesMale && getSeriesFemale && getCategories ? (
      <BottomBarGraph
        seriesMale={getSeriesMale}
        seriesFemale={getSeriesFemale}
        categories={getCategories}
      />
    ) : null}
  </>
)
};

export default AgeGenderGraph;
